import { render, staticRenderFns } from "./CompanionWorkshop.vue?vue&type=template&id=24567402&scoped=true&lang=pug&"
import script from "./CompanionWorkshop.vue?vue&type=script&lang=js&"
export * from "./CompanionWorkshop.vue?vue&type=script&lang=js&"
import style0 from "./CompanionWorkshop.vue?vue&type=style&index=0&id=24567402&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24567402",
  null
  
)

export default component.exports